module.exports = __webpack_public_path__ + "img/ico-registry.e36aff55.svg";